// extracted by mini-css-extract-plugin
export var infoItem = "_u9-2";
export var title = "_u9-0";
export var value = "_u9-1";